import Drawable from '../entities/Drawable.js';
import { c } from '../setup.js';

export default class NPCShadow extends Drawable {
    constructor({ npc, visible = true }) {
        super();
        this.npc = npc;
        this.position = {
            x: 0,
            y: 0,
        };
        this.visible = visible;
    }

    draw() {
        if (!this.visible) {
            return;
        }
        this.position.x = 240 / 2;
        this.position.y = 160 / 2 + 13;
        if (this.npc) {
            this.position.x = this.npc.effectivePosition().x + 8;
            this.position.y = this.npc.effectivePosition().y + 13;
        }

        // draw a 16px by 8px black ellipse with 50% opacity.
        c.save();
        c.beginPath();
        // ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, anticlockwise)
        c.ellipse(this.position.x, this.position.y, 7, 3, 0, 0, Math.PI * 2);
        c.fillStyle = 'rgba(0, 0, 0, 0.5)';
        c.fill();
        c.restore();
    }
}
